import { IconHighlightedSizeType } from '@kubit/web-ui-components/iconHighlighted/types';
import { TextDecorationType } from '@kubit/web-ui-components/text/types';
import { AvatarProfileSizeType } from '../../../../../components/avatarProfile/types/avatarProfileSizeType';
import { AvatarProfileType } from '../../../../../components/avatarProfile/types/avatarProfileType';
import { AvatarProfileVariantType } from '../../../../../components/avatarProfile/types/avatarProfileVariantType';
import { ErrorTextVariantType } from '../../../../../components/errorText/types/errorText';
import { FONT_WEIGHT } from '../../foundations/typography';
import { IconHighlightedVariantType } from '../iconHighlighted/variants';
import { TextVariantType } from '../text/variants';
export const commonStyles = (FOUNDATIONS, FONT, SHADOWS) => ({
    parentContainer: {
        display: 'flex',
        flex_direction: 'column',
        row_gap: FOUNDATIONS.spacing_150,
    },
    mainContainer: {
        display: 'flex',
        flex_direction: 'row',
        column_gap: FOUNDATIONS.spacing_150,
    },
    decorativeElementContainer: {
        display: 'flex',
        align_items: 'end',
    },
    messageContainer: {
        display: 'flex',
        flex_wrap: 'wrap',
        padding: `${FOUNDATIONS.spacing_125} ${FOUNDATIONS.spacing_150}`,
        align_items: 'baseline',
        justify_content: 'center',
        gap: FOUNDATIONS.spacing_100,
        flex_direction: 'column',
        filter: `drop-shadow(0 ${FOUNDATIONS.spacing_25} ${FOUNDATIONS.blur_25} ${FOUNDATIONS.color_effect_shadow_drop_100})`,
    },
    messageHyperlink: {
        font_family: 'inherit',
        font_size: 'inherit',
        line_height: 'inherit',
        font_weight: FONT_WEIGHT.font_bold,
        color: FOUNDATIONS.color_comp_actions_button_ghost_primary_default_font,
        text_decoration: TextDecorationType.UNDERLINE,
    },
    messageAndDecorativeTextContainer: {
        text_align: 'left',
        display: 'flex',
        flex_direction: 'column',
        flex: 1,
    },
    messageSubMessageContainer: {
        display: 'flex',
        width: '100%',
        align_items: 'end',
        justify_content: 'center',
        gap: FOUNDATIONS.spacing_125,
    },
    title: {
        font_variant: TextVariantType.FONT_PARAGRAPH_400,
        font_weight: FONT_WEIGHT.font_bold,
        color: FOUNDATIONS.color_exception_neutral_font_450,
        word_break: 'break-word',
    },
    message: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        font_weight: FONT_WEIGHT.font_regular,
        word_break: 'break-word',
    },
    subMessage: {
        font_variant: TextVariantType.FONT_PARAGRAPH_650,
        font_weight: FONT_WEIGHT.font_regular,
    },
    decorativeTextContainer: {
        width: 'fit-content',
        text_align: 'left',
        cursor: 'pointer',
    },
    decorativeText: {
        font_variant: TextVariantType.FONT_PARAGRAPH_400,
        font_weight: FONT_WEIGHT.font_bold,
        color: FOUNDATIONS.color_comp_actions_button_ghost_primary_default_font,
        text_decoration: TextDecorationType.UNDERLINE,
    },
    iconContainer: {
        display: 'flex',
        align_items: 'center',
    },
    icon: {
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
        color: FOUNDATIONS.color_neutral_icon_150,
    },
    errorText: {
        variant: ErrorTextVariantType.REGULAR,
    },
});
export const inboundMessageCommonStyles = (FOUNDATIONS, FONT, SHADOWS) => ({
    ...commonStyles(FOUNDATIONS, FONT, SHADOWS),
    mainContainer: {
        ...commonStyles(FOUNDATIONS, FONT, SHADOWS).mainContainer,
        justify_content: 'start',
    },
    decorativeElement: {
        avatarProfile: {
            variant: AvatarProfileVariantType.INITIALS,
            size: AvatarProfileSizeType.EXTRA_EXTRA_SMALL,
            type: AvatarProfileType.SELECTOR_MULTIPLE,
        },
        iconHighlighted: {
            variant: IconHighlightedVariantType.CIRCLE,
            size: IconHighlightedSizeType.EXTRA_EXTRA_SMALL,
        },
    },
    messageContainer: {
        ...commonStyles(FOUNDATIONS, FONT, SHADOWS).messageContainer,
        border_radius: `${FOUNDATIONS.radius_200} ${FOUNDATIONS.radius_200} ${FOUNDATIONS.radius_200} 0`,
        background_color: FOUNDATIONS.color_exception_neutral_bg_1100,
        gap: FOUNDATIONS.spacing_125,
        position: 'relative',
        border_bottom_left_radius: '5px',
        after: {
            content: '',
            position: 'absolute',
            width: '0px',
            height: '0px',
            border_style: 'solid',
            border_width: '16px 12px 0px 0px',
            border_color: `${FOUNDATIONS.color_exception_neutral_bg_1100} transparent transparent`,
            left: '-6px',
            display: 'block',
            bottom: '0px',
            border_radius: '10px 4px 5px 9px',
            transform: 'rotate(180deg)',
        },
    },
    message: {
        ...commonStyles(FOUNDATIONS, FONT, SHADOWS).message,
        color: FOUNDATIONS.color_neutral_font_50,
    },
    subMessage: {
        ...commonStyles(FOUNDATIONS, FONT, SHADOWS).subMessage,
        color: FOUNDATIONS.color_neutral_font_50,
    },
});
export const outboundMessageCommonStyles = (FOUNDATIONS, FONT, SHADOWS) => ({
    ...commonStyles(FOUNDATIONS, FONT, SHADOWS),
    mainContainer: {
        ...commonStyles(FOUNDATIONS, FONT, SHADOWS).mainContainer,
        justify_content: 'end',
    },
    messageContainer: {
        ...commonStyles(FOUNDATIONS, FONT, SHADOWS).messageContainer,
        border_radius: `${FOUNDATIONS.radius_200} ${FOUNDATIONS.radius_200} 0 ${FOUNDATIONS.radius_200}`,
        background_color: FOUNDATIONS.color_exception_neutral_bg_1200,
        position: 'relative',
        border_bottom_right_radius: '5px',
        after: {
            content: '',
            position: 'absolute',
            width: '0px',
            height: '0px',
            border_style: 'solid',
            border_width: '16px 12px 0px 0px',
            border_color: `${FOUNDATIONS.color_exception_neutral_bg_1200} transparent transparent`,
            right: '-9px',
            display: 'block',
            bottom: '-2px',
            border_radius: '10px 4px 5px 9px',
            transform: 'rotate(-82deg)',
        },
    },
    message: {
        ...commonStyles(FOUNDATIONS, FONT, SHADOWS).message,
        color: FOUNDATIONS.color_neutral_font_50,
    },
    icon: {
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
    },
});
//# sourceMappingURL=commonStyles.js.map